import atob from './atob';
export default (function (input) {
  return atob(input.replace(/-/g, '+').replace(/_/g, '/'));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/b2a/es/atobu.js
// module id = 956
// module chunks = 0